import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category?sort=year',
    icon: 'ri-time-line',
    title: '最新电影',
    desc: '按上映时间收录近年韩国剧情新作',
    tone: 'primary' as const,
  },
  {
    to: '/category?tag=影史经典',
    icon: 'ri-award-line',
    title: '经典理论片',
    desc: '影史留名的作者电影与理论范本',
    tone: 'accent' as const,
  },
  {
    to: '/special',
    icon: 'ri-quill-pen-line',
    title: '深度影评',
    desc: '沿专题脉络读懂影片背后的艺术',
    tone: 'secondary' as const,
  },
];

const toneMap = {
  primary: 'bg-primary-50 text-primary-700 border-primary-200/70',
  accent: 'bg-accent-50 text-accent-700 border-accent-200/70',
  secondary: 'bg-secondary-50 text-secondary-800 border-secondary-200/70',
};

const iconToneMap = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-primary-950',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function QuickEntries() {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
      {entries.map((e) => (
        <Link
          key={e.title}
          to={e.to}
          className={`group flex items-center gap-4 rounded-lg border p-4 md:p-5 transition-colors cursor-pointer ${toneMap[e.tone]}`}
        >
          <span className={`w-12 h-12 md:w-14 md:h-14 shrink-0 flex items-center justify-center rounded-md ${iconToneMap[e.tone]}`}>
            <i className={`${e.icon} text-2xl`} aria-hidden="true" />
          </span>
          <span className="min-w-0">
            <span className="flex items-center gap-1 font-heading text-base font-bold text-foreground-950">
              {e.title}
              <i className="ri-arrow-right-line text-sm opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" aria-hidden="true" />
            </span>
            <span className="mt-1 block text-xs text-foreground-600 line-clamp-2">{e.desc}</span>
          </span>
        </Link>
      ))}
    </section>
  );
}